export interface RequestHotelDisplayNameByLatLongInterface {
  latitude: number;
  longitude: number;
  type?: string;
}

export class ResponseHotelDisplayNameByLatLong {
  status: boolean; // required

  type: string; // required

  typeId: string; // required อาจเป็นค่า '' กรณี type = hotel, destination

  displayName: string; // required

  destinationId: string;

  hotelId: string;

  hotelSlug: string;

  areaSlug: string;

  citySlug: string;

  countrySlug: string;

  constructor(data: any) {
    this.status = data.status || false;
    this.type = data.type || "";
    this.typeId = data.typeId || "";
    this.displayName = data.displayName || "";
    this.destinationId = data.destinationId || "";
    this.hotelId = data.hotelId || "";
    this.hotelSlug = data.hotelSlug || "";
    this.areaSlug = data.areaSlug || "";
    this.citySlug = data.citySlug || "";
    this.countrySlug = data.countrySlug || "";
  }
}
